import { createStore } from "vuex";

import {
  auth,
  signInWithEmailAndPassword,
  signOut,
} from "../firebaseConfig.js";

export default createStore({
  state: {
    user: {
      loggedIn: false,
      data: null,
    },
    country: "South Africa",
    QuizResults: {
      winningMethods: [],
      selectedChoices: [],
      methodScores: {},
    },
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER_DATA(state, data) {
      state.user.data = data;
    },
    SET_COUNTRY(state, country) {
      state.country = country;
    },
    SET_QUIZ_RESULTS(state, QuizResults) {
      state.QuizResults = QuizResults;
    },
  },
  actions: {
    async logIn(context, { email, password }) {
      console.log("logIn User Action:" + email + password);
      const response = await signInWithEmailAndPassword(auth, email, password);
      if (response) {
        console.log("logIn User Action: response was true");
      } else {
        throw new Error("login failed");
      }
    },
    async logOut(context) {
      await signOut(auth);
      context.commit("SET_USER_DATA", null);
    },
    async fetchUser(context, user) {
      console.log("fetchUser Action is running");
      context.commit("SET_LOGGED_IN", user !== null);
      if (user) {
        context.commit("SET_USER_DATA", {
          displayName: user.displayName, // This might be null
          email: user.email,
        });
      } else {
        context.commit("SET_USER_DATA", null);
      }
    },
    setCountry({ commit }, country) {
      commit("SET_COUNTRY", country);
    },
    setQuizResults({ commit }, QuizResults) {
      commit("SET_QUIZ_RESULTS", QuizResults);
    },
  },
  getters: {
    user: (state) => state.user,
    loggedIn: (state) => state.user.loggedIn,
    country: (state) => state.country,
    QuizResults: (state) => state.QuizResults,
  },
  modules: {},
});
